/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import crel from "crel";
import { getHeadingDomAttrs } from "./nodes";
export class HeadingNodeView {
    constructor(node, view, getPos) {
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.type = node.type;
        const attrs = node.attrs;
        this.button = crel("button", {
            class: "heading-expand-button",
            contenteditable: "false",
            type: "button",
        }, "▼");
        this.contentDOM = crel("div", { class: "heading-content" });
        this.dom = crel(`h${attrs.level}`, getHeadingDomAttrs(attrs), [
            this.button,
            this.contentDOM,
        ]);
        this.button.addEventListener("click", () => {
            this.dispatchCollapse(!this.node.attrs.collapse);
        });
        this.update(node);
    }
    update(node) {
        if (node.type !== this.type ||
            node.attrs.level !== this.node.attrs.level ||
            node.content.size === 0) {
            // If the node type or level is changed, let node be destroyed
            return false;
        }
        this.node = node;
        const attrs = node.attrs;
        crel(this.dom, getHeadingDomAttrs(attrs));
        if (attrs.collapse) {
            this.button.textContent = "▶";
        }
        else {
            this.button.textContent = "▼";
        }
        return true;
    }
    /**
     * Dispatches a collapse transaction that changes the `collapse` heading node attribute and
     * calls the collapse plugin adding decorations to nodes that need to be collapsed.
     */
    dispatchCollapse(collapse) {
        this.view.dispatch(this.view.state.tr.setNodeMarkup(this.getPos(), null, {
            ...this.node.attrs,
            collapse,
        }));
    }
}
